import {Loader, LoaderOptions} from "google-maps";
import mapStyles from './../mapStyles';

export default class Map {
  constructor(rootNode) {
    this.$refs = {
      rootNode,
      markerList: document.querySelector('.MapMarkerList'),
    };

    this.loader = new Loader('AIzaSyDfKdDKkHamW2DKj89uNXFQLjY8t17rXyA', {});
    this.markers = Array.from(this.$refs.markerList.querySelectorAll('.item')) || [];
    this.activeMarker = null;

    this.setupMap();
  }

  setupMap() {
    this.loader.load().then(google => {
      const map = new google.maps.Map(this.$refs.rootNode, {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
        maxZoom: 11,
        styles: mapStyles,
        disableDefaultUI: true,
        gestureHandling: 'none',
        zoomControl: false
      });

      const bounds = new google.maps.LatLngBounds();
      let number = 1;

      this.renderCurrentPosition(google, map, bounds);
      this.markers.forEach(item => {
        this.createMarker(google, item.dataset.marker, map, number++, bounds);
      });

      map.fitBounds(bounds);
    });
  }

  createMarker(google, item, map, number, bounds) {
    const data = JSON.parse(item);
    const infowindow = new google.maps.InfoWindow({
      content: this.getInfoWindowContent(data),
      maxWidth: 260,
    });

    const marker = new google.maps.Marker({
      map,
      title: data.name,
      label: {
        text: `${number}`,
        color: 'white',
      },
      position: {
        lat: data.location.lat,
        lng: data.location.lng
      },
    });

    marker.addListener('click', () => {
      if (this.activeMarker) this.activeMarker.close();

      this.activeMarker = infowindow;
      infowindow.open(map, marker);
      this.setListActiveStateFor(data.id);
    });

    document.getElementById(`${data.id}`).addEventListener('click', () => {
      if (marker === this.activeMarker) return;
      if (this.activeMarker) this.activeMarker.close();

      this.activeMarker = infowindow;
      google.maps.event.trigger(marker, 'click');
    });

    bounds.extend(marker.position);
  }

  renderCurrentPosition(google, map, bounds) {
    const position = JSON.parse(this.$refs.rootNode.dataset.location);

    const marker = new google.maps.Marker({
      icon: {
        url: '/bundles/hausbesuche/images/user-marker.png',
        size: new google.maps.Size(26, 26),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(13, 13),
        zIndex: -1
      },
      position,
      map,
    });

    bounds.extend(marker.position);
  }

  setListActiveStateFor(id) {
    this.markers.forEach(item => {
      if (item.id === id) item.classList.add('is-active');
      else item.classList.remove('is-active');
    });
  }

  getInfoWindowContent(data) {
    return `
      <div class="content text-center">
        <img src="${data.img}" class="image">
        <p class="text-size-s text-color-grey marker-location-text">
          ${data.city ? data.city + ', ' : ''}${data.distance} km entfernt
        </p>
        
        <h2 class="Title is-size-1">
          ${data.name}
        </h2>
        
        <div class="text-size-s">
            statt ${data.rawPrice}

            <h3 class="Title is-size-3">
                ${data.specialPrice}
            </h3>
        </div>
        
        <a href="${data.link.url}" class="Button text-center text-size-l">${data.link.label}</a>
      </div>
    `;
  }
}
